import { ILogger } from './types';

export default class ConsoleLogger implements ILogger {
  public debug = (msg?: string, ...optionalParams: any[]): void => {
    console.debug(msg, ...optionalParams);
  };

  public info = (msg?: string, ...optionalParams: any[]): void => {
    console.info(msg, ...optionalParams);
  };

  public warn = (msg?: string, ...optionalParams: any[]): void => {
    console.warn(msg, ...optionalParams);
  };

  public error = (err: Error, ...optionalParams: any[]): void => {
    console.error(err.message, ...optionalParams);
  };

  public trace = (msg?: string, ...optionalParams: any[]): void => {
    console.trace(msg, ...optionalParams);
  };
}
